import * as React from 'react';
import { Component } from 'react';
import _ from 'lodash';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SimpleLoader from 'components/loaders/SimpleLoader';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import FullPageLoader from 'components/loaders/FullPageLoader';
import { withTranslation, WithTranslation } from 'react-i18next';
import { InspectionViewExecutionStep } from 'types/rest/analyticsTypes';
import AnalyticsEventList from 'views/Analytics/AnalyticsMockService/Inspection/RequestDetail/EventList/AnalyticsEventList';

type AllProps = WithTranslation & RequestEventDetailsProps;

type RequestEventDetailsProps = {
  executionSteps: InspectionViewExecutionStep[];
};

interface EventDetailsStateProps {
  isRightSidePaneLoading: boolean;
  executionSteps: InspectionViewExecutionStep[];
  currentStep: InspectionViewExecutionStep;
  isLoading: boolean;
  id: number;
}

class RequestEventDetails extends Component<AllProps, EventDetailsStateProps> {
  /** Maps execution steps*/
  state: EventDetailsStateProps = {
    executionSteps: this.props.executionSteps,
    currentStep: this.props.executionSteps[0],
    isRightSidePaneLoading: false,
    isLoading: true,
    id: 0,
  };

  componentDidUpdate(prevProps: Readonly<AllProps>) {
    if (prevProps.executionSteps !== this.props.executionSteps) {
      this.setState({
        executionSteps: this.props.executionSteps,
        currentStep: this.props.executionSteps[0],
      });
    }
  }

  currentRequestDetailChanged = (executionSteps: InspectionViewExecutionStep) => {
    this.setState({
      currentStep: executionSteps,
    });
  };

  /**
   * Generates nav item for single request detail.
   * @param executionSteps
   */
  getNavItemDom = (executionSteps: InspectionViewExecutionStep) => {
    const txnName = executionSteps.name;
    return (
      <Nav.Item title={txnName} key={executionSteps.name} className="w-100">
        <Nav.Link
          className="text-truncate"
          eventKey={executionSteps.id}
          onSelect={() => this.currentRequestDetailChanged(executionSteps)}
          onKeyDown={() => _.noop()}
        >
          <span>{txnName}</span>
        </Nav.Link>
      </Nav.Item>
    );
  };

  getNavPaneDom = () => {
    return (
      <AnalyticsEventList
        executionSteps={this.state.currentStep.events}
        eventGroupName={this.state.currentStep.name}
        key={this.state.currentStep.name}
      />
    );
  };

  render() {
    const { executionSteps, isRightSidePaneLoading } = this.state;

    if (_.isNil(executionSteps)) {
      return <SimpleLoader />;
    }

    if (executionSteps.length !== 0) {
      const navTabs: any[] = executionSteps.map((executionStep: InspectionViewExecutionStep) => {
        return this.getNavItemDom(executionStep);
      });

      const defaultActiveKey = executionSteps.length !== 0 && executionSteps[0].id !== null ? executionSteps[0].id : '';
      const currentActiveKey = this.state.currentStep ? this.state.currentStep.id : undefined;

      return (
        <Tab.Container id="left-tabs-example" defaultActiveKey={defaultActiveKey} activeKey={currentActiveKey}>
          <Row>
            <Col xs={3} xl={2} className={'border-right border-gray'} style={{ maxHeight: '100vh', overflow: 'auto' }}>
              <h2>
                {this.props.t('analytics:inspection.executionStepEvents')} ({executionSteps.length})
              </h2>
              <Nav
                activeKey={defaultActiveKey}
                variant="pills"
                className="nav nav-pills nav-pills-vertical nav-pills-left flex-column"
              >
                {navTabs}
              </Nav>
            </Col>
            <Col xs={9} xl={10}>
              <Tab.Content>
                <div style={{ position: 'relative' }}>
                  {isRightSidePaneLoading && (
                    <div className="blur-background">
                      <FullPageLoader />
                    </div>
                  )}
                  <div className={isRightSidePaneLoading ? 'blur' : ''}>{this.getNavPaneDom()}</div>
                </div>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      );
    } else {
      return <p>{this.props.t('analytics:inspection.noResultsText')}</p>;
    }
  }
}

export default withTranslation()(RequestEventDetails);
